import {Button, Stack} from "@mui/material";
import {useCallback} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {useUser} from '../../api/index.js';
import MonitorDelete from '../../components/Monitors/MonitorDelete.js';
import MonitorInformationForm from '../../components/Monitors/MonitorInformationForm.js';
import useDialogControls from '../../hooks/use-dialog-controls.js';

const Monitor = () => {
  const {id} = useParams();
  const {data} = useUser(id as string);
  const {open, reset, setOpen} = useDialogControls([]);
  const navigate = useNavigate();
  const onDelete = useCallback(() => {
    reset();
    navigate('/monitors');
  }, [reset, navigate]);

  return (
    <>
      <Stack>
        <MonitorInformationForm
          values={data}
          monitorId={id as string}
        />
      </Stack>
      <Button
        onClick={() => setOpen(true)}
        color={"error"}
        variant={'contained'}
        sx={{mt: 2}}
      >
        Delete
      </Button>
      {data && id ?
        <MonitorDelete name={data.name as string} id={id as string} open={open} onSubmit={onDelete} onClose={reset}/>
        : null
      }

    </>
  );
};

export default Monitor;
